import React from 'react';

function Footer() {
  return (
    <div className="text-center pb-4">
      <div className="flex flex-wrap justify-center items-center gap-4 text-muted-foreground text-xs">
        <span className="flex items-center gap-1.5">
          <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full"></div>
          14-day money-back guarantee
        </span>
        <span className="text-muted-foreground/50">•</span>
        <span className="flex items-center gap-1.5">
          <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
          Cancel anytime
        </span>
        <span className="text-muted-foreground/50">•</span>
        <span className="flex items-center gap-1.5">
          <div className="w-1.5 h-1.5 bg-purple-500 rounded-full"></div>
          No hidden fees
        </span>
      </div>
    </div>
  );
}

export default Footer;
